import React from 'react';
import { Col, Container } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { useSelector } from '@yme/hooks/useSelector';
import { getCurrentSku, getRTL } from '@yme/selectors/common';
import { getIsLoadedProductDetails, getVariantsLongIntroductionText, } from '@yme/selectors/products';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { LongIntroductionSectionSkeleton } from './LongIntroductionSectionSkeleton';
import { getCurrentLongIntroductions } from './helpers';
import { RowStyled, HeadingLevel2Styled, RegularTextLevel3Styled } from './styled';
export function LongIntroductionSection(props) {
    const { isRemoveBottomIndent, isInEditor } = props;
    const longIntroductionsVariants = useSelector(getVariantsLongIntroductionText);
    const currentSku = useSelector(getCurrentSku);
    const isRightToLeft = useSelector(getRTL);
    const isLoadedProductDetails = useSelector(getIsLoadedProductDetails);
    const currentLongIntroductions = getCurrentLongIntroductions(currentSku, longIntroductionsVariants);
    if (!isLoadedProductDetails && !isInEditor) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(LongIntroductionSectionSkeleton, null)));
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent || !currentLongIntroductions?.productOverviewHeader }, currentLongIntroductions?.productOverviewHeader && (React.createElement(Container, { isRightToLeft: isRightToLeft },
        React.createElement(RowStyled, null,
            React.createElement(Col, { lg: 6 },
                React.createElement(HeadingLevel2Styled, null, currentLongIntroductions?.productOverviewHeader),
                React.createElement(RegularTextLevel3Styled, null, currentLongIntroductions?.productLongIntroB || ''),
                React.createElement(RegularTextLevel3, null, currentLongIntroductions?.productLongIntroC || '')))))));
}
LongIntroductionSection.displayName = 'LongIntroductionSection_AEMComponent';
